/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Authorization, AuthorizationFromJSON, AuthorizationToJSON,} from './Authorization';

/**
 *
 * @export
 * @interface AuthorizationApiResult
 */
export interface AuthorizationApiResult {
    /**
     *
     * @type {boolean}
     * @memberof AuthorizationApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Authorization}
     * @memberof AuthorizationApiResult
     */
    content?: Authorization;
    /**
     *
     * @type {string}
     * @memberof AuthorizationApiResult
     */
    message?: string | null;
}

export function AuthorizationApiResultFromJSON(json: any): AuthorizationApiResult {
    return AuthorizationApiResultFromJSONTyped(json, false);
}

export function AuthorizationApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorizationApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : AuthorizationFromJSON(json['content']),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function AuthorizationApiResultToJSON(value?: AuthorizationApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': AuthorizationToJSON(value.content),
        'message': value.message,
    };
}

